import {connect} from 'react-redux';
import {updateOrder} from '../actions/changeOrders';
import OrderDetails from '../components/OrderDetails';

const mapStateToProps = state => ({
    orders: state.orders,
    getOrder: orderName => (state.orders.filter(order => order.name === orderName).pop()),
    getFiles: () => (state.files)
});

const mapDispatchToProps = dispatch => ({
    updateOrder: order => dispatch(updateOrder(order))
});

const FormDetails = connect(mapStateToProps, mapDispatchToProps)(OrderDetails);

export default FormDetails;


// WEBPACK FOOTER //
// ./src/app/containers/FormDetails.js